module.exports = __webpack_public_path__ + "img/logo-icon-app.bd22db76.png";